import { ReviewRequest } from '../../../services/ReviewService'
import { TableCellBody, TableCellBodyParams } from '../AppTable/TableCellBody'

export const ReviewRequestTableCellBody = (params?: TableCellBodyParams<ReviewRequest>) =>
  TableCellBody<ReviewRequest>(params)
